import * as yup from 'yup'

export const CancelPolicyFormValidationSchema = yup.object().shape({
  basicDetails: yup.object().shape({
    name: yup.string().required('This field is required'),
    description: yup.string().required('This field is required'),
    descriptionTranslatedList: yup
      .array()
      .of(
        yup
          .object()
          .shape({
            label: yup.string(),
            nativeLabel: yup.string(),
            value: yup.string()
          })
          .required('This field is required')
      )
      .not(
        [
          [
            {
              label: 'persian name',
              nativeLabel: 'فارسی',
              value: ''
            }
          ]
        ],
        'This field is required'
      )
  }),
  table: yup.array().min(1)
})
